import { Global, css } from "@emotion/react";
import { useTheme } from "@mui/material/styles";

const GlobalStyle = () => {
  const theme = useTheme();

  return (
    <Global
      styles={css`
        html,
        body,
        #root {
          height: 100%;
        }

        body {
          margin: 0;
        }

        .MuiCardHeader-action .MuiIconButton-root {
          padding: 4px;
          width: 28px;
          height: 28px;
        }

        body > iframe {
          pointer-events: none;
        }

        /* DataGrid dark mode text color fixes - only in dark mode */
        ${theme.palette.mode === "dark"
          ? `
        .MuiDataGrid-footerContainer {
          color: ${theme.palette.text.primary};
        }

        .MuiDataGrid-footerContainer .MuiTablePagination-root {
          color: ${theme.palette.text.primary};
        }

        .MuiDataGrid-footerContainer .MuiTablePagination-root .MuiTablePagination-displayedRows {
          color: ${theme.palette.text.primary};
        }

        .MuiDataGrid-footerContainer .MuiTablePagination-root .MuiTablePagination-selectLabel {
          color: ${theme.palette.text.primary};
        }

        .MuiDataGrid-footerContainer .MuiTablePagination-root .MuiTablePagination-select {
          color: ${theme.palette.text.primary};
        }

        .MuiDataGrid-footerContainer .MuiTablePagination-root .MuiTablePagination-actions {
          color: ${theme.palette.text.primary};
        }

        .MuiDataGrid-footerContainer .MuiTablePagination-root .MuiTablePagination-actions .MuiIconButton-root {
          color: ${theme.palette.text.primary};
        }

        /* Custom footer components */
        .MuiDataGrid-footerContainer .MuiTypography-root {
          color: ${theme.palette.text.primary};
        }

        .MuiDataGrid-footerContainer .MuiFormControl-root .MuiInputBase-root {
          color: ${theme.palette.text.primary};
        }

        .MuiDataGrid-footerContainer .MuiFormControl-root .MuiInputBase-root .MuiSelect-select {
          color: ${theme.palette.text.primary};
        }

        .MuiDataGrid-footerContainer .MuiFormControl-root .MuiInputBase-root .MuiSelect-icon {
          color: ${theme.palette.text.primary};
        }
        `
          : ""}

        /* DataGrid row text color fixes for colored backgrounds */
        .MuiDataGrid-row.pastelGreen .MuiDataGrid-cell {
          color: #000000 !important;
        }

        .MuiDataGrid-row.pastelRed .MuiDataGrid-cell {
          color: #000000 !important;
        }

        .MuiDataGrid-row.pastelBlue .MuiDataGrid-cell {
          color: #000000 !important;
        }

        /* AddMultipleClaimForm minimum amount validation colors */
        .MuiDataGrid-row.pastelGreen {
          background-color: #b2f2bb !important;
        }

        .MuiDataGrid-row.pastelRed {
          background-color: #ffc9c9 !important;
        }

        /* AddMultipleClaimForm text color for colored rows - 80% black */
        .MuiDataGrid-row.pastelGreen .MuiDataGrid-cell {
          color: #333333 !important;
        }
        .MuiDataGrid-row.pastelRed .MuiDataGrid-cell {
          color: #333333 !important;
        }

        /* Checkbox styling for colored rows */
        .MuiDataGrid-row.pastelGreen .MuiCheckbox-root {
          color: #333333 !important;
        }
        .MuiDataGrid-row.pastelRed .MuiCheckbox-root {
          color: #333333 !important;
        }

        .MuiDataGrid-row.pastelGreen .MuiCheckbox-root.Mui-checked {
          color: #000000 !important;
        }
        .MuiDataGrid-row.pastelRed .MuiCheckbox-root.Mui-checked {
          color: #000000 !important;
        }

        /* AddMultipleClaimForm icon color fixes for colored rows - 80% black */
        .MuiDataGrid-row.pastelGreen .MuiIconButton-root .MuiSvgIcon-root {
          color: #333333 !important;
        }
        .MuiDataGrid-row.pastelRed .MuiIconButton-root .MuiSvgIcon-root {
          color: #333333 !important;
        }

        /* AddMultipleClaimForm hover styling for minimum amount validation - 66% black */
        .MuiDataGrid-row.pastelGreen:hover .MuiDataGrid-cell {
          color: #555555 !important;
        }
        .MuiDataGrid-row.pastelRed:hover .MuiDataGrid-cell {
          color: #555555 !important;
        }

        /* AddMultipleClaimForm icon hover styling - 66% black */
        .MuiDataGrid-row.pastelGreen:hover .MuiIconButton-root .MuiSvgIcon-root {
          color: #555555 !important;
        }
        .MuiDataGrid-row.pastelRed:hover .MuiIconButton-root .MuiSvgIcon-root {
          color: #555555 !important;
        }

        /* Checkbox hover styling for colored rows - 66% black */
        .MuiDataGrid-row.pastelGreen:hover .MuiCheckbox-root {
          color: #555555 !important;
        }
        .MuiDataGrid-row.pastelRed:hover .MuiCheckbox-root {
          color: #555555 !important;
        }

        /* AddMultipleClaimForm ultra-specific hover overrides - 66% black */
        .MuiDataGrid-root .MuiDataGrid-row.pastelGreen:hover .MuiDataGrid-cell,
        .MuiDataGrid-root .MuiDataGrid-row.pastelRed:hover .MuiDataGrid-cell {
          color: #555555 !important;
        }

        /* AddMultipleClaimForm ultra-specific icon hover overrides - 66% black */
        .MuiDataGrid-root .MuiDataGrid-row.pastelGreen:hover .MuiIconButton-root .MuiSvgIcon-root,
        .MuiDataGrid-root .MuiDataGrid-row.pastelRed:hover .MuiIconButton-root .MuiSvgIcon-root {
          color: #555555 !important;
        }

        /* AddMultipleClaimForm ultra-specific checkbox hover overrides - 66% black */
        .MuiDataGrid-root .MuiDataGrid-row.pastelGreen:hover .MuiCheckbox-root,
        .MuiDataGrid-root .MuiDataGrid-row.pastelRed:hover .MuiCheckbox-root {
          color: #555555 !important;
        }

        /* AddMultipleClaimForm even more specific hover selectors - 66% black */
        .MuiDataGrid-root .MuiDataGrid-row.pastelGreen:hover .MuiDataGrid-cell *,
        .MuiDataGrid-root .MuiDataGrid-row.pastelRed:hover .MuiDataGrid-cell * {
          color: #555555 !important;
        }

        /* AddMultipleClaimForm even more specific icon hover selectors - 66% black */
        .MuiDataGrid-root .MuiDataGrid-row.pastelGreen:hover .MuiIconButton-root .MuiSvgIcon-root *,
        .MuiDataGrid-root .MuiDataGrid-row.pastelRed:hover .MuiIconButton-root .MuiSvgIcon-root * {
          color: #555555 !important;
        }

        /* Ensure text is readable in colored rows */
        .pastelGreen {
          color: #000000 !important;
        }

        .pastelRed {
          color: #000000 !important;
        }

        .pastelBlue {
          color: #000000 !important;
        }

        /* General text color fixes for dark mode - only in dark mode */
        ${theme.palette.mode === "dark"
          ? `
        .MuiTypography-root {
          color: ${theme.palette.text.primary};
        }

        .MuiTab-root {
          color: ${theme.palette.text.primary};
        }

        .MuiTab-root.Mui-selected {
          color: ${theme.palette.primary.main};
        }

        .MuiTabs-root {
          background-color: ${theme.palette.background.paper};
        }

        /* Fix any remaining black text issues */
        .MuiCard-root .MuiTypography-root {
          color: ${theme.palette.text.primary};
        }

        .MuiPaper-root .MuiTypography-root {
          color: ${theme.palette.text.primary};
        }

        .MuiBox-root .MuiTypography-root {
          color: ${theme.palette.text.primary};
        }

        /* Dark text on intentionally light surfaces (chat bubbles, contact cards, etc.) */
        .text-on-light-surface,
        .text-on-light-surface .MuiTypography-root,
        .text-on-light-surface .MuiSvgIcon-root,
        .text-on-light-surface .MuiIconButton-root {
          color: #212121 !important;
        }

        .text-on-light-surface .MuiDivider-root {
          border-color: rgba(0, 0, 0, 0.12) !important;
        }

        .text-on-light-surface .MuiIconButton-root.Mui-disabled,
        .text-on-light-surface .MuiIconButton-root.Mui-disabled .MuiSvgIcon-root {
          color: rgba(0, 0, 0, 0.38) !important;
        }
        `
          : ""}

        /* ViewClaimDialog DataGrid colored row text fixes */
        .MuiDataGrid-row.highlight-row .MuiDataGrid-cell {
          color: #000000 !important;
        }
        .MuiDataGrid-row.highlight-row-removed .MuiDataGrid-cell {
          color: #000000 !important;
        }
        .MuiDataGrid-row.highlight-row-ready-for-claim .MuiDataGrid-cell {
          color: #000000 !important;
        }
        .MuiDataGrid-row.highlight-row-not-claimable .MuiDataGrid-cell {
          color: #000000 !important;
        }

        /* DataGrid hover styling for colored rows - only in dark mode */
        ${theme.palette.mode === "dark"
          ? `
        /* DataGrid hover styling for highlight rows */
        .MuiDataGrid-row:hover .highlight-row .MuiDataGrid-cell {
          color: #ffffff !important;
        }
        .MuiDataGrid-row:hover .highlight-row-removed .MuiDataGrid-cell {
          color: #ffffff !important;
        }
        .MuiDataGrid-row:hover .highlight-row-ready-for-claim .MuiDataGrid-cell {
          color: #ffffff !important;
        }
        .MuiDataGrid-row:hover .highlight-row-not-claimable .MuiDataGrid-cell {
          color: #ffffff !important;
        }

        /* DataGrid hover styling for pastel colored rows */
        .MuiDataGrid-row:hover .pastelBlue .MuiDataGrid-cell {
          color: #ffffff !important;
        }


        /* More specific hover selectors for colored rows */
        .MuiDataGrid-root .MuiDataGrid-row:hover.pastelBlue .MuiDataGrid-cell {
          color: #ffffff !important;
        }

        /* Force text color on hover for all colored rows */
        .pastelBlue:hover .MuiDataGrid-cell {
          color: #ffffff !important;
        }

        /* Ultra-specific hover overrides */
        .MuiDataGrid-root .MuiDataGrid-row.pastelBlue:hover .MuiDataGrid-cell,
        .MuiDataGrid-root .MuiDataGrid-row.highlight-row:hover .MuiDataGrid-cell,
        .MuiDataGrid-root .MuiDataGrid-row.highlight-row-removed:hover .MuiDataGrid-cell,
        .MuiDataGrid-root .MuiDataGrid-row.highlight-row-ready-for-claim:hover .MuiDataGrid-cell,
        .MuiDataGrid-root .MuiDataGrid-row.highlight-row-not-claimable:hover .MuiDataGrid-cell {
          color: #ffffff !important;
        }


        /* Even more specific - target the actual cell content */
        .MuiDataGrid-root .MuiDataGrid-row.pastelBlue:hover .MuiDataGrid-cell *,
        .MuiDataGrid-root .MuiDataGrid-row.highlight-row:hover .MuiDataGrid-cell *,
        .MuiDataGrid-root .MuiDataGrid-row.highlight-row-removed:hover .MuiDataGrid-cell *,
        .MuiDataGrid-root .MuiDataGrid-row.highlight-row-ready-for-claim:hover .MuiDataGrid-cell *,
        .MuiDataGrid-root .MuiDataGrid-row.highlight-row-not-claimable:hover .MuiDataGrid-cell * {
          color: #ffffff !important;
        }

        `
          : ""}

        /* DataGrid dropdown styling for dark mode - only in dark mode */
        ${theme.palette.mode === "dark"
          ? `
        .MuiDataGrid-root .MuiTextField-root .MuiOutlinedInput-root {
          background-color: ${theme.palette.background.paper} !important;
          color: ${theme.palette.text.primary} !important;
        }

        .MuiDataGrid-root .MuiTextField-root .MuiOutlinedInput-notchedOutline {
          border-color: ${theme.palette.divider} !important;
        }

        .MuiDataGrid-root .MuiTextField-root .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
          border-color: ${theme.palette.primary.main} !important;
        }

        .MuiDataGrid-root .MuiTextField-root .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
          border-color: ${theme.palette.primary.main} !important;
        }
        `
          : ""}

        /* Date field calendar icon styling for dark mode - only in dark mode */
        ${theme.palette.mode === "dark"
          ? `
        .MuiTextField-root[type="date"] .MuiInputAdornment-root .MuiSvgIcon-root {
          color: ${theme.palette.text.primary} !important;
        }

        .MuiTextField-root .MuiInputAdornment-root .MuiSvgIcon-root {
          color: ${theme.palette.text.primary} !important;
        }

        .MuiTextField-root .MuiOutlinedInput-adornedEnd .MuiSvgIcon-root {
          color: ${theme.palette.text.primary} !important;
        }

        .MuiTextField-root .MuiOutlinedInput-root .MuiSvgIcon-root {
          color: ${theme.palette.text.primary} !important;
        }

        /* More specific selectors for date picker icons */
        input[type="date"] + .MuiSvgIcon-root {
          color: ${theme.palette.text.primary} !important;
        }

        .MuiTextField-root input[type="date"] + .MuiSvgIcon-root {
          color: ${theme.palette.text.primary} !important;
        }

        /* Override any black calendar icons */
        .MuiTextField-root .MuiSvgIcon-root {
          color: ${theme.palette.text.primary} !important;
        }

        /* General input styling for dark mode */
        input[type="date"] {
          color: ${theme.palette.text.primary} !important;
        }
        `
          : ""}

        /* Browser native date picker icon styling - only in dark mode */
        input[type="date"]::-webkit-calendar-picker-indicator {
          filter: ${theme.palette.mode === "dark" ? "invert(1)" : "invert(0)"} !important;
        }

        input[type="date"]::-webkit-inner-spin-button,
        input[type="date"]::-webkit-outer-spin-button {
          filter: ${theme.palette.mode === "dark" ? "invert(1)" : "invert(0)"} !important;
        }

        /* Firefox date picker */
        input[type="date"]::-moz-calendar-picker-indicator {
          filter: ${theme.palette.mode === "dark" ? "invert(1)" : "invert(0)"} !important;
        }
      `}
    />
  );
};

export default GlobalStyle;
